import { render, staticRenderFns } from "./IoPropListPanel.vue?vue&type=template&id=4e6bda80&scoped=true"
import script from "./IoPropListPanel.vue?vue&type=script&lang=js"
export * from "./IoPropListPanel.vue?vue&type=script&lang=js"
import style0 from "./IoPropListPanel.vue?vue&type=style&index=0&id=4e6bda80&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e6bda80",
  null
  
)

export default component.exports